module.exports = __webpack_public_path__ + "img/scene_icon.9576642f.svg";